import { c as _c } from "react/compiler-runtime";
import { AllowlistDescription } from "@/components/allowlist-tool/allowlist-tool.types";
import EmmaListSearchItem from "./EmmaListSearchItem";
export default function EmmaListSearchItemsContent(t0) {
  const $ = _c(11);
  const {
    selectedId,
    loading,
    items,
    onSelect
  } = t0;
  if (loading) {
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
      t1 = <li className="tw-py-2 tw-w-full tw-h-full tw-flex tw-items-center tw-justify-between tw-text-sm tw-font-medium tw-text-white tw-rounded-lg tw-relative tw-select-none tw-px-2">Loading...</li>;
      $[0] = t1;
    } else {
      t1 = $[0];
    }
    return t1;
  }
  if (items.length) {
    let t1;
    if ($[1] !== items || $[2] !== onSelect || $[3] !== selectedId) {
      let t2;
      if ($[5] !== onSelect || $[6] !== selectedId) {
        t2 = item => <EmmaListSearchItem key={item.id} item={item} selectedId={selectedId} onSelect={onSelect} />;
        $[5] = onSelect;
        $[6] = selectedId;
        $[7] = t2;
      } else {
        t2 = $[7];
      }
      t1 = items.map(t2);
      $[1] = items;
      $[2] = onSelect;
      $[3] = selectedId;
      $[4] = t1;
    } else {
      t1 = $[4];
    }
    let t2;
    if ($[8] !== t1) {
      t2 = <>{t1}</>;
      $[8] = t1;
      $[9] = t2;
    } else {
      t2 = $[9];
    }
    return t2;
  }
  let t1;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <li className="tw-py-2 tw-w-full tw-h-full tw-flex tw-items-center tw-justify-between tw-text-sm tw-font-medium tw-text-white tw-rounded-lg tw-relative tw-select-none tw-px-2">No results</li>;
    $[10] = t1;
  } else {
    t1 = $[10];
  }
  return t1;
}